import BaseComponentController from '.././base-component.controller';

class AcknowledgementsComponentController extends BaseComponentController {
    constructor(_, componentRegistryService, $q, $sce) {
        super(_, componentRegistryService, $q);
        this._ = _;
        this.sce = $sce;
        this.vm = {
            errors: []
        };
    }

    init() {
        if (!this.model) {
            this.model = {};
            this._.forEach(this.acknowledgementItems, (ack) => { this.model[ack.id] = false; });
        }
        this.vm = {
            errors:[],
            errorFields:null
        };
    }

    validate() {
        this.vm = {
            errors:[],
            errorFields:null
        };
        if(!this._.isEmpty(this._.pickBy(this.model, (value, key) => value === false))) {
            this.vm.errors = ['Please ensure all of the acknowlegements are ticked before confirming submission'];
            this.vm.errorFields = this._.mapKeys(this.model, (value, key) => {
                if (!value) {
                    return key;
                }
            });
        } else {
            this.vm.errors = [];
        }
        return this.vm.errors.length === 0;
    }

    validateAsync() {
        return this.getPromise(this.validate());
    }

    renderHtml(html) {
        return this.sce.trustAsHtml(html);
    }
}

AcknowledgementsComponentController.$inject = ['_', 'componentRegistryService','$q', '$sce'];

export default  {
controller: AcknowledgementsComponentController,
    bindings: {
        fieldName:'@',
        modelName:'@',
        acknowledgementItems: '<'
    },
templateUrl:`app/components/acknowledgements/acknowledgements.html`
};




// WEBPACK FOOTER //
// ./app/components/acknowledgements/acknowledgements.component.js